import { msg } from '@lingui/core/macro';
import type { MetaTagsProps } from './resolvePageMetadata';

type FieldMetadata = {
    id: number;
    slug: string;
    name: string;
    works_count: number | null;
    description: string | null;
};

/** Keep exported taxonomy HTML and hydrated page metadata in sync. */
export function fieldMetadataProps(field: FieldMetadata): MetaTagsProps {
    return {
        surfaceId: 'field-detail',
        canonicalPathname: `/field/${field.id}/${field.slug}`,
        title: {
            ...msg({
                id: 'seo.field.title',
                message: 'Research papers in {fieldName}. Discover {paperCount, number} academic papers with AI-powered analysis',
            }),
            values: { fieldName: field.name, paperCount: field.works_count || 0 },
        },
        description: {
            ...msg({
                id: 'seo.field.description',
                message: 'Research papers in {fieldName}. Discover {paperCount, number} academic papers with AI-powered analysis. {fieldDescription}',
            }),
            values: {
                fieldName: field.name,
                paperCount: field.works_count || 0,
                fieldDescription: field.description ?? '',
            },
        },
    };
}
